import { React, useState } from "react";
import Person3Icon from '@mui/icons-material/Person3';
import ForumIcon from '@mui/icons-material/Forum';
import BannerBreadcrumb from "../Components/BannerBreadcrumb";
const InterestRates = () => {
    const uniqueFeatures = [
        {
            title: "1. When does the interest on education loans initiate?",
            content: "Interest on an education loan begins when the money is given to the student. While studying, most lenders charge simple interest. Once the study period and grace period are over, compound interest is applied."
        },
        {
            title: "2. Is there a way to reduce the interest on a student loan?",
            content: "TVarious subsidies are available from the government to ease the financial strain on students. Some of these include Padho Pardesh, Dr. Ambedkar Central Sector Scheme, and Central Sector Interest Subsidy Scheme.",
            content1: "It’s an interest subsidy program for those in lower economic categories. The student is eligible for the interest subsidy given that family income does not exceed INR 4.5 lakhs.",
            content2: "This program aims to offer financial support to students from Other Backward Classes and Economically Weaker Classes who wish to pursue their education abroad. Through this interest subsidy scheme, the government aims to encourage and promote foreign education opportunities for these students.",
            head: "Central Sector Interest Subsidy - ",
            head1: "Dr. Ambedkar Central Sector Scheme - "
        },
        {
            title: "3. How may I apply for a foreign education loan interest subsidy?",
            content: "You can get the subsidies by getting in touch with the bank or lender in concern. To proceed, you must apply along with several required documents. These documents consist of an original income certificate, an agreement for interest subsidy, a student letter issued by your institute, a self-declaration form, and some additional documents."
        },
        {
            title: "4. Are tax deductions applicable to education loans?",
            content: "You may get a tax deduction on the interest paid for a loan taken for higher education under Section 80E of the Income Tax Act of 1961. This deduction applies to the total interest amount of the Equated Monthly Instalments (EMI) paid in a financial year."
        }, {
            title: "5. What expenses are taken care of by the loan?",
            content: "The cost of your tuition, living expenses, study materials, and accommodation while pursuing a degree will all be covered by education loans."
        },
        {
            title: "6. Is it possible to obtain a student loan without needing collateral?",
            content: "You can get an education loan from either public or private banks without having to provide any collateral. Just be aware that the interest rate could be elevated."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"Interest Rates"} pagename={"Interest Rates"} />
            <section className="blog-section">
                <div className="container">

                    <div className="loan-eligibility">
                        <p className="loan-elegibility-des mt-0">The interest rate is the amount of money that a lender charges on the principal loan amount. There will be a monthly payment needed in addition to the principal amount if you take out a loan to fund your study abroad program. Interest rates on student loans may vary based on several factors, including the borrower’s creditworthiness, the loan type, and the lender’s policy.<br /><br />
                            To make sound decisions about getting loans for higher education, it is essential to have a thorough understanding of the interest rates on student loans for studying overseas.</p>
                        <h5 className="about-head">Different Kinds of Interest Rates</h5>
                        <table className="table table-bordered table-striped customtable mt-4 mb-4">
                            <thead className="table-head">
                                <tr>
                                    <th className="text-center">Floating Interest Rate</th>
                                    <th className="text-center">Fixed Interest Rate</th>

                                </tr>

                            </thead>
                            <tbody className="table-body">
                                <tr>
                                    <td className="interest-data">
                                        <ol className="subhead-ul">
                                            <li>Fluctuations may occur throughout the loan.</li>
                                            <li>Influenced by shifts in financial market conditions.</li>
                                            <li>Hard to plan your payments as they are susceptible to vary.</li>
                                            <li>No fixed EMIs.</li>
                                        </ol></td>
                                    <td className="interest-data">

                                        <ol className="subhead-ul">
                                            <li>Stay unchanged throughout the loan term.</li>
                                            <li>Unaffected by fluctuations in financial market conditions.</li>
                                            <li>Ensure fixed Equated Monthly Installments (EMIs).</li>
                                            <li>Help you plan your payments in advance.</li>
                                        </ol></td>

                                </tr>

                            </tbody>
                        </table>


                        <h5 className="about-head">What is the method used to calculate interest rates?</h5>
                        <table className="table table-bordered table-striped customtable mt-4 mb-4">
                            <thead className="table-head">
                                <tr>
                                    <th className="text-center">Simple Interest</th>
                                    <th className="text-center">Compound Interest</th>

                                </tr>

                            </thead>
                            <tbody className="table-body">
                                <tr>
                                    <td className="interest-data"><p className="loan-elegibility-des"><b>SI = (P x r x t)/100</b></p>
                                        <p className="loan-elegibility-des"><b>Here :</b></p>
                                        <ol className="subhead-ul">
                                            <li>SI denotes the Simple Interest.</li>
                                            <li>P stands for the Principal Amount.</li>
                                            <li>r represents the Rate of Interest.</li>
                                            <li>t stands for the number of years.</li>
                                        </ol>
                                        <p className="loan-elegibility-des"><b>Example –</b> Let’s consider a scenario where you take a loan of INR 50,000 for 1 year with an interest rate of 5%. Applying the formula, the interest amount comes out to be INR 2500. Consequently, when you repay the borrowed sum, an additional payment of INR 2500 is required as a fee.</p></td>
                                    <td className="interest-data"><p className="loan-elegibility-des"><b>A = P (1 + r/n) nt</b></p>
                                        <p className="loan-elegibility-des"><b>Here :</b></p>
                                        <ol className="subhead-ul">
                                            <li>A stands for compound interest amount.</li>
                                            <li>P is the principal amount.</li>
                                            <li>r is the interest rate per annum.</li>
                                            <li>n – The number of times the interest gets compounded in a year.</li>
                                            <li>t signifies the number of years.</li>
                                        </ol>
                                        <p className="loan-elegibility-des"><b>Example –</b> If you borrow 10 lakhs INR at a 10% interest rate for 5 years.</p>
                                        <ol className="subhead-ul">
                                            <li>Overall interest to be Paid – INR 4,97,916</li>
                                            <li>Total Payment (Principal + Interest) – INR 14,97,916</li>
                                            <li>Per Moth EMI – INR 24,965</li>

                                        </ol></td>

                                </tr>

                            </tbody>
                        </table>


                        <h5 className="about-head">Aspects that Affect the Rate of Interest for Education Loans</h5>
                        <h6 className="subhead">
                            Category of Loan
                        </h6>
                        <p className="loan-elegibility-des">Secured loans are considered to be a safer option as they require the borrower to provide collateral. By offering this guarantee to the bank, the borrower can enjoy a lower interest rate on their loan. On the other hand, unsecured loans do not involve any collateral, resulting in higher interest rates being charged for this type of loan.</p>



                        <h6 className="subhead">Applicant profile</h6>
                        <p className="loan-elegibility-des">The applicant profile includes information about the student’s prior academic records, past work experience, income history, credit score, and other factors.</p>

                        <h6 className="subhead">Co-applicant profile</h6>
                        <p className="loan-elegibility-des">When someone applies for a loan, having a co-applicant or co-borrower can assure that the loan will be repaid even if the main applicant is unable to do so. This is because the co-applicant’s credit score and income are taken into consideration to assess the level of risk involved, which in turn affects the interest rate offered.</p>

                        <h6 className="subhead">Market Conditions</h6>
                        <p className="loan-elegibility-des">The interest rates of education loans can be influenced by various factors, such as the current market conditions, the overall economic environment, and trends in interest rates.</p>

                        <h5 className="about-head text-center">Frequently Asked Questions</h5>
                        {uniqueFeatures.map((item, idx) => (
                            <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                    {item.title}
                                    <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                </button>
                                <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                    <p className="loan-eligibility-des mb-0">{item.content}</p>
                                    <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                    <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </section >
        </>
    )
}

export default InterestRates;